// extracted by mini-css-extract-plugin
export default {"departments":"dF-z","departmentHeading":"eF-z","departmentSection":"fF-z","departmentName":"gF-z","departmentLink":"hF-z","expandIcon":"iF-z"};